<!-- Light/Dark Mode Button -->
<!--<button type="button" class="light-dark-toggle leading-none inline-block transition-all text-orange-400
        absolute top-[20px] md:top-[25px]
        ltr:right-[20px] rtl:left-[20px] ltr:md:right-[25px] rtl:md:left-[25px]"
        (click)="toggleTheme()">
    <i class="material-symbols-outlined !text-[20px] md:!text-[22px]">
        light_mode
    </i>
</button>-->

<!-- Confirm Delivery -->
<div class="min-h-screen bg-white dark:bg-[#0a0e19] flex items-center justify-center py-3 px-4">
    <div class="w-full mx-auto">
        <div class="grid grid-cols-1 lg:grid-cols-2 items-center">

            <!-- Image -->
            <div class="rounded-[25px] order-2 lg:order-1 overflow-hidden shadow-lg">
                <img src="images/confirm-email.jpg" alt="confirm-email-image" class="w-full h-full object-cover rounded-[25px]">
            </div>

            <!-- Content -->
            <div class="order-1 lg:order-2 xl:ltr:pl-[90px] xl:rtl:pr-[90px] 2xl:ltr:pl-[120px] 2xl:rtl:pr-[120px] flex flex-col items-start gap-6">

                <!-- Logo + Success Icon -->
                <div class="flex items-center justify-between w-full">

                    <!-- Logo -->
                    <div>
                        <img src="images/logo_loomisFx.png" alt="logo" class="inline-block dark:hidden h-20">
                        <img src="images/logo_loomisFx_dark.png" alt="logo" class="hidden dark:inline-block h-20">
                    </div>

                    <!-- Success Icon -->
                    <div class="flex items-center justify-center w-16 h-16 rounded-full bg-green-100 dark:bg-green-900/30">
                        <i class="material-symbols-outlined text-green-500 dark:text-green-400 !text-[36px]">
                            check_circle
                        </i>
                    </div>

                </div>

                <!--openstreetmap-->
                <div id="map" class="w-full rounded-xl" style="width:100%;height: 450px;"></div>

                <!--<iframe width="100%"
                        height="450"
                        frameborder="0"
                        scrolling="no"
                        marginheight="0"
                        marginwidth="0"
                        src="https://www.openstreetmap.org/export/embed.html?bbox=2.505903%2C48.813594%2C2.509903%2C48.815594&layer=mapnik&marker=48.814594%2C2.507903">
                </iframe>-->

                <!-- Messages -->
                <div class="flex flex-col gap-2">
                    <h1 class="!font-bold !text-2xl lg:!text-3xl text-gray-800 dark:text-white !mb-0">
                        {{lang('Opération terminée.')}}
                    </h1>
                    <p class="text-base text-gray-500 dark:text-gray-400">
                        {{lang('Vous pouvez fermer cette fenêtre.')}}
                    </p>
                </div>

                <!-- Divider -->
                <!--<div class="w-16 h-1 rounded-full bg-orange-400"></div>-->
            </div>

        </div>
    </div>
</div>
